
export default {
  install: function (Vue) {
    Vue.prototype.formatDate = (date) => formatDate(date);
    Vue.prototype.getCurrDate = (date) => getCurrDate(date);
    Vue.prototype.getYears = () => getYears();
    Vue.prototype.addMinutes = (minute) => addMinutes(minute);
    Vue.prototype.addMonths = (month) => addMonths(month);
    Vue.prototype.idcardShield = (idcard) => idcardShield(idcard);
    Vue.prototype.formatHourMinute = (date) => formatHourMinute(date);
    Vue.prototype.formatDateTime = (date) => formatDateTime(date);
    Vue.prototype.getCurrentWeekStartDate= () => getCurrentWeekStartDate();
    Vue.prototype.getSevenDaysDate= (date) => getSevenDaysDate(date);
    Vue.prototype.getCurrentMonthStartDate= () => getCurrentMonthStartDate();
    Vue.prototype.getNextMonthEndDate= (date) => getNextMonthEndDate(date);
    Vue.prototype.getCurrentQuarterStartDate= () => getCurrentQuarterStartDate();
    Vue.prototype.getCurrentQuarterEndDate= () => getCurrentQuarterEndDate();
    Vue.prototype.getCurrentYearStartDate= () => getCurrentYearStartDate();
    Vue.prototype.getCurrentYearEndDate= () => getCurrentYearEndDate();
    Vue.prototype.isIdcard = (idcard) => isIdcard(idcard);
    Vue.prototype.formatString = (str, args) => formatString(str, args);
    Vue.prototype.getLocalSymptoms = (depart, sex, months) => getLocalSymptoms(depart, sex, months);
  }
}

function getSevenDaysDate(date) {
  let result=[];
  for(let i=0; i< 7; i++){
    date.setTime(date.getTime() + 1000*60*60*24);
    result.push({date:formatDate(date), samll:((date.getMonth() + 1)+'.'+date.getDate()), week:'日一二三四五六'.charAt(date.getDay())});
  }
  return result;
}

function getLocalSymptoms(depart, sex, months){
  let result = [];
  let symptoms = JSON.parse(localStorage.getItem("symptoms"));
  if(undefined != symptoms && null != symptoms && symptoms.length > 0){
    symptoms.forEach(function (item) {
      if(undefined != item.children && null != item.children && item.children.length >0){
        let children = item.children;
        if(undefined != depart && null != depart && '' != depart){
          children = children.filter(e=>(undefined == e.departments || null == e.departments
              || e.departments.length <= 0 || e.departments.includes(depart)));
        }
        if(undefined != sex && null != sex && '' != sex){
          children = children.filter(e=>(undefined == e.sex || null == e.sex || e.sex == sex));
        }
        if(undefined != months && null != months && months > 0){
          children = children.filter(e=>{
            if(undefined == e.age || null == e.age || null == e.age) {
              return true;
            }
            if(e.age.start.months < months && e.age.end.months >= months){
              return true;
            }
            return false;
          });
        }

        if(children.length > 0){
          result.push(Object.assign(item, {children: children}));
        }
      }
    });
  }

  return result;
}

function idcardShield(idcard){
  if(null != idcard && '' != idcard){
    if(idcard.trim().length == 15){
      return idcard.substring(0,11)+'****'+idcard.substring(14);
    }else if(idcard.trim().length == 18){
      return idcard.substring(0,12)+'****'+idcard.substring(16);
    }
  }
  return '-';
}
function addMinutes(minute) {
  var date = new Date();
  date.setMinutes(date.getMinutes() + minute);

  return date.getTime();
}

/**
 * 几个月之后
 * @param minute
 * @returns {string}
 */
function addMonths(addMonth) {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth();
  var day = 31;
  var num = month + addMonth;
  if(num>12){
    year+=Math.floor(num/12) ;
    month=num%12;
  }else{
    month = num;
  }
  return formatDate(new Date(year,month, day))

}
/**
 * 日期格式化
 * @param date
 * @returns {string}
 */
function formatDate(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (month <= 9) {
    month = "0" + month;
  }
  if (day <= 9) {
    day = "0" + day;
  }
  return year + "-" + month + "-" + day;
}

function getYears(){
    var result = new Array();
    var now = new Date(); //当前日期
    var current = now.getFullYear();

    for(var i=2018; i<=(current+1); i++){
        result.push(i);
    }
    return result;
}

function getCurrDate(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (month <= 9) {
    month = "0" + month;
  }
  if (day <= 9) {
    day = "0" + day;
  }
  return year + "-" + month + "-" + day;
}

function formatHourMinute(date) {
  var hour = date.getHours();
  var minute = date.getMinutes();

  if (hour <= 9) {
    hour = "0" + hour;
  }
  if (minute <= 9) {
    minute = "0" + minute;
  }
  return hour + ":" + minute;
}

function formatDateTime(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();

  if (month <= 9) {
    month = "0" + month;
  }
  if (day <= 9) {
    day = "0" + day;
  }
  if (hour <= 9) {
    hour = "0" + hour;
  }
  if (minute <= 9) {
    minute = "0" + minute;
  }
  if (second <= 9) {
    second = "0" + second;
  }
  return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
}
/**
 * 本周开始时间
 * @returns {string}
 */
function getCurrentWeekStartDate(){
  var now = new Date(); //当前日期
  var weekDay = now.getDay(); //今天本周的第几天
  var nowDay = now.getDate(); //当前日
  var nowMonth = now.getMonth(); //当前月
  var nowYear = now.getFullYear(); //当前年
  var date = new Date(nowYear, nowMonth, nowDay - weekDay);
  return formatDate(date);
}

function getNextMonthEndDate(date){
  var nowMonth = date.getMonth()+2; //当前月
  var nowYear = date.getFullYear(); //当前年
  var date = new Date(nowYear, nowMonth, 0);
  return formatDate(date);
}
/**
 * 本月开始时间
 * @returns {string}
 */
function getCurrentMonthStartDate(){
  var now = new Date(); //当前日期
  var nowMonth = now.getMonth(); //当前月
  var nowYear = now.getFullYear(); //当前年
  var date = new Date(nowYear, nowMonth, 1);
  return formatDate(date);
}
/**
 * 本季度开始时间
 * @returns {string}
 */
function getCurrentQuarterStartDate(){
  var now = new Date(); //当前日期
  var nowYear = now.getFullYear(); //当前年
  var nowMonth = now.getMonth(); //当前月
  if(nowMonth <3 ){
    nowMonth = 0;
  }else if(2 < nowMonth && nowMonth < 6){
    nowMonth = 3;
  }else if(5 < nowMonth && nowMonth < 9){
    nowMonth = 6;
  }else if(8 < nowMonth && nowMonth < 11){
    nowMonth = 9;
  }
  var date = new Date(nowYear, nowMonth, 1);
  return formatDate(date);
}

/**
 * 获取当前季度最后一天
 * @returns {string}
 */
function getCurrentQuarterEndDate(){
  var now = new Date(); //当前日期
  var nowYear = now.getFullYear(); //当前年
  var nowMonth = now.getMonth(); //当前月
  if(nowMonth <3 ){
    nowMonth = 3;
  }else if(2 < nowMonth && nowMonth < 6){
    nowMonth = 6;
  }else if(5 < nowMonth && nowMonth < 9){
    nowMonth = 9;
  }else if(8 < nowMonth && nowMonth < 11){
    nowYear ++;
    nowMonth = 0;
  }
  var date = new Date(nowYear, nowMonth, 1);
  date.setDate(date.getDate()-1);
  return formatDate(date);
}

/**
 * 本年
 * @returns {string}
 */
function getCurrentYearStartDate(){
  var now = new Date(); //当前日期
  var nowYear = now.getFullYear(); //当前年
  var date = new Date(nowYear, 0, 1);
  return formatDate(date);
}

/**
 * 本年
 * @returns {string}
 */
function getCurrentYearEndDate(){
  var now = new Date(); //当前日期
  var nowYear = now.getFullYear(); //当前年
  var date = new Date(nowYear, 11, 31);
  return formatDate(date);
}

function isIdcard(idcard) {
    let reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2})$/;
    return reg.test(idcard);
}



function formatString(str, args) {
  let result = str;
  for (let key in args) {
    if (args[key] != undefined) {
      result = result.replace('{' + key + '}', args[key]);
    }
  }
  return result;
}